const { Mixin } = require('@xingternal/hops');

class FormRuntimeMixin extends Mixin {
  enhanceServerData(serverData, _req, res) {
    let enhancedServerData = {
      ...serverData,
      language: res.locals.language,
      requestTime: res.locals.requestTime,
    };

    if (!res.locals.loginFormState) return enhancedServerData;

    const {
      attemptedUsername,
      authPartner,
      knownUser,
      notice,
      error,
    } = res.locals.loginFormState;

    const formMessage = {
      notice,
      error,
    };

    return {
      ...enhancedServerData,
      attemptedUsername,
      authPartner,
      formMessage,
      knownUser,
    };
  }
}

module.exports = FormRuntimeMixin;
